var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product',{attrs:{"title":"Amazfit 全压胶防风透湿冲锋衣","swiper-data":_vm.swiperData,"slogan":_vm.slogan,"price":"199","colors":_vm.colors,"relatived-products":_vm.relativedProducts,"detail-images":_vm.detailImages,"param-images":_vm.paramImages,"buy-link":"https://j.youzan.com/hJUkKh"}})
}
var staticRenderFns = []

export { render, staticRenderFns }